.uat-environment-banner,
.dev-environment-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  padding: 5px 15px;
  min-height: 50px;
}

.uat-environment-banner {
  background-color: #6238a2;
}

.dev-environment-banner {
  background-color: #1e6b45;
}

.uat-environment-banner-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.uat-environment-logo {
  flex-shrink: 0;
  border: 1px solid #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  padding: 6px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.uat-environment-message {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}

.uat-environment-banner-nav {
  float: none !important;
  margin: 0 !important;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.uat-environment-banner-nav > li {
  float: none;
  display: flex;
  align-items: center;
}

.uat-environment-banner-nav > li > a,
.uat-environment-banner-nav > li > a:hover,
.uat-environment-banner-nav > li > a:focus,
.uat-environment-banner-nav :global(.dropdown-toggle),
.uat-environment-banner-nav :global(.dropdown-toggle:hover),
.uat-environment-banner-nav :global(.dropdown-toggle:focus),
.uat-environment-banner-nav :global(.btn),
.uat-environment-banner-nav :global(.btn:hover),
.uat-environment-banner-nav :global(.btn:focus) {
  color: #fff !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.uat-environment-logout-btn,
.uat-environment-logout-btn:hover,
.uat-environment-logout-btn:focus,
.uat-environment-logout-btn:active {
  color: #fff !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  text-decoration: underline;
  white-space: nowrap;
}

.uat-environment-banner-nav .caret {
  border-top-color: #fff;
}

.uat-language-nav-item {
  display: flex;
  align-items: center;
  float: none;
}

.uat-banner-language-selector {
  padding-bottom: 0 !important;
}

.uat-banner-language-btn,
.uat-banner-language-btn:hover,
.uat-banner-language-btn:focus,
.uat-banner-language-btn:active,
.uat-banner-language-selector button[class*='selectBtn'] {
  color: #fff !important;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  margin-top: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}

.uat-banner-language-btn:after,
.uat-banner-language-selector button[class*='selectBtn']:after,
.uat-environment-banner-nav .uat-banner-language-selector button[class*='selectBtn']:after {
  margin-left: 2px !important;
  border-top: 4px solid #fff !important;
  border-left: 4px solid transparent !important;
  border-right: 4px solid transparent !important;
  border-bottom: 0 !important;
}

.uat-banner-language-btn[aria-expanded='true']:after,
.uat-banner-language-selector button[class*='selectBtn'][aria-expanded='true']:after,
.uat-environment-banner-nav .uat-banner-language-selector button[class*='selectBtn'][aria-expanded='true']:after {
  border-top: 0 !important;
  border-bottom: 4px solid #fff !important;
  border-left: 4px solid transparent !important;
  border-right: 4px solid transparent !important;
}

.uat-banner-language-selector [class*='selectValue'],
.uat-banner-language-selector [class*='selectFlag'] {
  background: transparent !important;
  background-color: transparent !important;
}

.uat-banner-language-selector svg {
  background: transparent !important;
  background-color: transparent !important;
}

.uat-main-navbar,
.non-prod-main-navbar {
  margin-bottom: 0;
  border-radius: 0;
}
